import { createResource, type Match, type Query } from '@atlassian/react-resource-router';
import { getProjectKey } from '@atlassian/jira-router-resources-utils/src/utils/get-project-key-id/index.tsx';
import { performGetRequest } from '@atlassian/jira-fetch';

export type IssueCollapsibleGroup = {
	id: string;
	initialOpened: boolean;
	projectKey: string;
};

export type IssueCollapsibleGroupData = {
	[id: string]: IssueCollapsibleGroup;
};

const getKey = ({ match, query }: { match: Match; query: Query }) => {
	const projectKey = getProjectKey(match, query);
	return `issue.collapsible-group.${projectKey}`;
};

export const issueCollapsibleGroupDataResource = createResource<
	IssueCollapsibleGroupData | undefined
>({
	type: 'ISSUE_COLLAPSIBLE_GROUP_DATA',
	getKey,
	getData: async ({ match, query }) => {
		const key = getKey({ match, query });
		const requestUrl = `/rest/api/3/mypreferences?key=${key}`;
		return performGetRequest(requestUrl);
	},
	isBrowserOnly: false,
});
